import { render, staticRenderFns } from "./UpAnimation.vue?vue&type=template&id=ffecf768&scoped=true&"
import script from "./UpAnimation.vue?vue&type=script&lang=js&"
export * from "./UpAnimation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffecf768",
  null
  
)

export default component.exports